<div class="division-section">
    <r1-compass-lib-instructions headerText="Enabled Divisions">
        To add a new division/configuration, click the '+Add Division' button.
    </r1-compass-lib-instructions>
    <div class="divisions-list">
        @for (divisionTuple of enabledDivisions(); track $index) {
            <div class="division-row">
                <div class="division-name" [attr.data-testid]="'enabledOrPendingOrPaused' + $index">
                    {{ divisionTuple.iamDivision.divisionCode }}
                </div>
                <div class="division-enable-status" [class]="divisionTuple.statusClass">
                    {{ divisionTuple.divisionConfig.status }}
                </div>
                <button class="division-options" mat-button [matMenuTriggerFor]="optionsMenu" type="button">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #optionsMenu="matMenu">
                    <button mat-menu-item (click)="onToggleDivisionEnable(false, divisionTuple)" type="button">
                        Disable
                    </button>
                    @if (divisionTuple.divisionConfig.status === 'Paused') {
                        <button mat-menu-item (click)="onToggleDivisionPause(divisionTuple)" type="button">
                            Resume
                        </button>
                    } @else if (divisionTuple.divisionConfig.status === 'Enabled') {
                        <button mat-menu-item (click)="onToggleDivisionPause(divisionTuple)" type="button">
                            Pause
                        </button>
                    }
                    <button mat-menu-item (click)="onEditDivision('rename', divisionTuple)" type="button">
                        Rename
                    </button>
                </mat-menu>
            </div>
        } @empty {
            <p>(No enabled divisions)</p>
        }
        <button mat-raised-button color="primary" id="add-division-btn" (click)="onEditDivision('add')" type="button">
            + Add Division
        </button>
    </div>
</div>
<div class="division-section">
    <r1-compass-lib-instructions headerText="Disabled Divisions">
        To re-enable a division/configuration, click the options on the division and select 'Enable'
    </r1-compass-lib-instructions>
    <div class="divisions-list">
        @for (divisionTuple of disabledDivisions(); track $index) {
            <div class="division-row">
                <div class="division-name" [attr.data-testid]="'disabled' + $index">
                    {{ divisionTuple.iamDivision.divisionCode }}
                </div>
                <div class="division-enable-status" [class]="divisionTuple.statusClass">Disabled</div>
                <button class="division-options" mat-button [matMenuTriggerFor]="optionsMenu" type="button">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #optionsMenu="matMenu">
                    <button mat-menu-item (click)="onToggleDivisionEnable(true, divisionTuple)" type="button">
                        Enable
                    </button>
                    <button mat-menu-item (click)="onEditDivision('rename', divisionTuple)" type="button">
                        Rename
                    </button>
                </mat-menu>
            </div>
        } @empty {
            <p>(No disabled divisions)</p>
        }
    </div>
</div>
<div class="footer-container">
    <button mat-raised-button color="primary" (click)="onSave()" type="submit">Save</button>
</div>
